import Split from 'react-split'
import styles from './SplitDisplay.module.css'
import { useCallback, useEffect, useState } from 'react'
// import { Popover, Transition } from '@headlessui/react'
import TwitterScreenshot from './twitter_equivalent.png'
import TwitterMobileScreenshot from './twitter_equivalent_mobile3-noshadow.png'
import CommentsScreenshot from './blotter_comments_screenshot_short.png'
import CommentsMobileScreenshot from './blotter_comments_mobile3_lesslessshadow.png'
import classNames from 'classnames'
// import Arrow1Icon from 'components/Icons/Arrows/Arrow1'
// import Arrow2Icon from 'components/Icons/Arrows/Arrow2'
// import Arrow3Icon from 'components/Icons/Arrows/Arrow3'
// import Arrow4Icon from 'components/Icons/Arrows/Arrow4'
import BrowserBarMock from 'components/BrowserBarMock'
import { throttle } from 'lodash'
import Clickable from 'components/Clickable'
import { ArrowsExpandIcon, SelectorIcon } from '@heroicons/react/outline'
import Image from 'next/image'
// import CycleArrowIcon from 'components/Icons/Arrows/CycleArrow'
import StraightArrowIcon from 'components/Icons/Arrows/StraightArrow'
// import colors from 'tailwindcss/colors'
// import { createRoot } from 'react-dom/client'
import SlightCurve from 'components/Icons/Arrows/SlightCurve'

const SplitDisplay = () => {
  const [isDraggingSplit, setIsDraggingSplit] = useState(false)
  const [splitSizes, setSplitSizes] = useState([50,50])
  const [hideLeft, setHideLeft] = useState(true)
  const [hideRight, setHideRight] = useState(true)
  const [hideSecondary, setHideSecondary] = useState(true)
  // console.log('RERENDER')
  const showLeftView = () => {
    setSplitSizes([97, 3])
    setHideRight(true)
    setTimeout(() => { setHideLeft(false) }, 200)
  }
  const showRightView = () => {
    setSplitSizes([3, 97])
    setHideLeft(true)
    setTimeout(() => { setHideRight(false) }, 200)
  }
  const showSplitView = () => {
    setSplitSizes([50, 50])
    setTimeout(() => {
      setHideLeft(false)
      setHideRight(false)
    }, 200)
  }
  const runAnimation = useCallback(() => {
    setTimeout(showLeftView, 100)
    setTimeout(showRightView, 3000)
    setTimeout(() => {
      showSplitView()
      setHideSecondary(false)
    }, 6000)
    window.removeEventListener('scroll', runAnimation)
  }, [])
  useEffect(() => {
    window.addEventListener('scroll', runAnimation, { passive: true })
  }, [runAnimation])
  // const dragFnDebounced = useCallback(throttle((sizes: number[]) => {
  //   const [left, right] = sizes
  //   splitHandler(left, right)
  // }, 100), [hideLeft, hideRight, setHideLeft])
  const dragFnDebounced = throttle((sizes: number[]) => {
    const [left, right] = sizes
    if (left < 30) {
      // setHideLeft(hideLeft => {
      //   console.log('SET HIDE LEFT', hideLeft)
      //   return !hideLeft ? undefined : true
      // })
      setHideLeft(true)
    }
    if (left > 30) {
      setHideLeft(false)
    }
    if (right < 30) {
      setHideRight(true)
    }
    if (right > 30) {
      setHideRight(false)
    }
    // splitHandler(left, right, hideLeft, hideRight)
  }, 50)

  return <div className={styles.splitDisplay}>
    <div className={styles.splitContainer}>
      <Split
        sizes={splitSizes}
        minSize={10}
        expandToMin={false}
        gutterSize={10}
        gutterAlign='center'
        // gutter={getGutterElement}
        gutterStyle={gutterStyleFn}
        // snapOffset={30}
        dragInterval={1}
        onDragStart={() => { setIsDraggingSplit(true)}}
        onDragEnd={() => {
          setIsDraggingSplit(false)
          restoreGutterCursors()
        }}
        onDrag={dragFnDebounced}
        direction='horizontal'
        cursor='col-resize'
        className={styles.split}
      >
        <div className={classNames(styles.splitItem, { [styles.splitDragging]: isDraggingSplit })}>
          <div className='hidden md:block'>
            <BrowserBarMock className='hidden md:block max-w-full md:max-w-none md:w-[680px]' />
            <img
              src={TwitterScreenshot.src}
              className={styles.screenshotDesktop}
              aria-hidden='true'
            />
          </div>
          <div className={styles.screenshotMobile}>
            <Image
              src={TwitterMobileScreenshot}
              placeholder='blur'
              priority
              aria-hidden='true'
            />
          </div>

          <Clickable
            onClick={(e) => {
              e.preventDefault()
              hideRight
                ? showRightView()
                : hideLeft
                  ? showSplitView()
                  : showLeftView()
            }}
            className={styles.showTwitterView}
          >
            <div className={ hideLeft ? styles.showLabelHidden : styles.showLabel}>
              { hideRight
                ? <div className='rotate-90'>
                  <SelectorIcon className={styles.expandIcon} />
                </div>
                : <ArrowsExpandIcon className={styles.expandIcon} />
              }
              {/* Show { hideLeft ? 'Blog Post' : 'Twitter' } View */}
              Show { hideRight ? 'Blog' : 'Twitter' } View
            </div>
          </Clickable>
        </div>
        <div className={classNames(styles.splitItem, { [styles.splitDragging]: isDraggingSplit })}>
          <div className={styles.splitRight}>
          <Clickable
            onClick={
              (e) => {
                e.preventDefault()
                hideLeft
                  ? showLeftView()
                  : hideRight
                    ? showSplitView()
                    : showRightView()
              }
            }
            className={styles.showBlogView}
          >
            <div className={ hideRight ? styles.showLabelHidden : styles.showLabel}>
              {/* Show { hideRight ? 'Twitter' : 'Blog Post' } View */}
              { hideLeft
                ? <div className='rotate-90'>
                  <SelectorIcon className={styles.expandIcon} />
                </div>
                : <ArrowsExpandIcon className={styles.expandIcon} />
              }
              Show { hideLeft ? 'Twitter' : 'Blog' } View
            </div>
          </Clickable>
          </div>
        </div>
      </Split>
      <div className={styles.splitHackRight}>
        <div className='hidden md:block'>
          <BrowserBarMock className='hidden md:block max-w-full md:max-w-none md:w-[680px]' />
          <img
            src={CommentsScreenshot.src}
            className={styles.screenshotDesktopHack}
            alt='Screenshot of Blotter Comments'
          />
        </div>
        <div className={styles.screenshotMobile}>
          <Image
            src={CommentsMobileScreenshot}
            placeholder='blur'
            priority
            alt='Screenshot of Blotter Comments'
          />
        </div>
      </div>
      <div className={hideLeft ? styles.labelOnTwitterHidden : styles.labelOnTwitter}>
        <div className={styles.textOnTwitter}>On<br />Twitter</div>
        <div className={styles.arrowOnTwitter}>
          <SlightCurve />
          {/* <Arrow1Icon /> */}
        </div>
      </div>
      <div className={hideRight ? styles.labelOnBlogHidden : styles.labelOnBlog}>
        <div className={styles.textOnBlog}>In Your Blog’s Comments</div>
        <div className={styles.arrowOnBlog}>
          <SlightCurve />
          {/* <Arrow2Icon /> */}
        </div>
      </div>
      <div className={hideLeft || hideSecondary ? styles.labelSyncTwitterHidden : styles.labelSyncTwitter}>
        <div className={styles.textSyncTwitter}>Tweet Replies<br />Sync To<br />Blog Comments</div>
        <div className={styles.arrowSyncTwitter}>
          <StraightArrowIcon tailScale={ hideRight ? 7 : 4 } fill='#EB48A0' />
        </div>
        <div className={styles.arrowSyncTwitterMobile}>
          <StraightArrowIcon tailScale={ hideRight ? 2.5 : 1 } fill='#EB48A0' />
        </div>
      </div>
      <div className={hideRight || hideSecondary ? styles.labelSyncBlogHidden : styles.labelSyncBlog}>
        <div className={styles.textSyncBlog}>Blog Comments<br />Sync To<br />Tweet Replies</div>
        <div className={styles.arrowSyncBlog}>
          <StraightArrowIcon tailScale={ hideLeft ? 7 : 4 } fill='#EB48A0' />
        </div>
        <div className={styles.arrowSyncBlogMobile}>
          <StraightArrowIcon tailScale={ hideLeft ? 2.5 : 1 } fill='#EB48A0' />
        </div>
      </div>
    </div>
  </div>
}

const gutterStyleFn = () => ({
  backgroundImage: 'url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAeCAYAAADkftS9AAAAIklEQVQoU2M4c+bMfxAGAgYYmwGrIIiDjrELjpo5aiZeMwF+yNnOs5KSvgAAAABJRU5ErkJggg==\')',
  backgroundColor: '#000c',
  width: '16px',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center',
  cursor: 'col-resize',
})

// ugh so hacky, split.js https://github.com/nathancahill/split/issues/99
const restoreGutterCursors = () => {
  const hGutters = document.getElementsByClassName('gutter-horizontal')
  for (let i = 0; i < hGutters.length; ++i) {
    hGutters[i].classList.add('horizontalGutter')
  }
  // const vGutters = document.getElementsByClassName('gutter-vertical')
  // for (let i = 0; i < vGutters.length; ++i) {
  //   vGutters[i].classList.add('verticalGutter')
  // }
}

export default SplitDisplay
